import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UserActivateDialogStore } from './user-activate-dialog.store';
import { contentGlobalSuccess } from '../../../content.error';
import { BaseDialogComponent } from '../../../../../components/kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../../../components/kit/action-buttons/action-buttons.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-user-activate-dialog',
    templateUrl: './user-activate-dialog.component.html',
    styleUrl: './user-activate-dialog.component.scss',
    providers: [UserActivateDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ActionButtonsComponent,
        TranslatePipe,
    ],
})
export class UserActivateDialogComponent extends BaseDialogComponent implements OnInit {
    protected store = inject(UserActivateDialogStore);

    userId: string | null = null;

    ngOnInit() {
        this.userId = this.dialogConfig.data.userId;
    }

    protected async activateUser(): Promise<void> {
        if (!this.userId) {
            return;
        }
        await this.store.api.activateUser({ userId: this.userId });
        contentGlobalSuccess.next('user.messages.activated');
        this.dialogRef.close();
    }
}
